"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Trophy, Sparkles } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function AuthorityHeader() {
  const {
    loading
  } = useEcommerceProducts();
  if (loading) {
    return <div className="relative z-10 mx-auto max-w-6xl rounded-2xl border border-border/10 bg-card/10 p-8 backdrop-blur-2xl md:p-10">
        <div className="flex h-32 items-center justify-center animate-pulse">
          <div className="h-8 w-32 rounded-md bg-muted/30"></div>
        </div>
      </div>;
  }
  return <div className="relative z-10 mx-auto max-w-6xl overflow-hidden rounded-2xl border border-primary/20 bg-card/60 p-6 shadow-2xl backdrop-blur-xl md:p-8">
      {/* Decorative Gradient */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-transparent"></div>

      <div className="relative flex flex-col items-center justify-center text-center">
        {/* Updated Badge */}
        <Badge variant="secondary" className="mb-4 flex items-center gap-1.5 px-3 py-1 text-sm font-semibold shadow-lg bg-primary/20 text-primary border-primary/30">
          <Sparkles className="size-3.5" />
          DIRECTOR VERIFIED
        </Badge>

        <h2 className="font-heading mb-3 text-4xl font-extrabold tracking-tight text-foreground md:text-5xl lg:text-7xl">
          1 BILLION+ VIEWS SERVED
        </h2>

        <div className="font-default max-w-2xl text-base text-muted-foreground md:text-xl">
          <p>
            Applying 25 years of traditional cinematic directing to high-fidelity AI production. 
            Old Hollywood Pedigree. New-World Neural Speed.
          </p>
        </div>

        {/* Accolade Ticker */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-xs font-semibold text-primary/90">
          <div className="flex items-center gap-1.5">
            <Trophy className="size-3.5" />
            <span>ADDY Winner</span>
          </div>
          <span className="hidden text-muted-foreground/30 md:block">|</span>
          <span>Telly Winner</span>
          <span className="hidden text-muted-foreground/30 md:block">|</span>
          <span>Viral Creator</span>
        </div>

        <p className="mt-6 text-[10px] font-bold tracking-[0.2em] text-muted-foreground/50 uppercase">
          THE FUTURE IS GENERATED.
        </p>
      </div>
    </div>;
}
export default function CinematicContactHero() {
  return <section id="contact-authority-header" className="relative overflow-hidden bg-[#020203] px-4 py-8 text-foreground md:py-12">
      {/* Background Ambient Glow */}
      <div className="absolute inset-0 z-0 opacity-40">
        <div className="absolute -left-[10%] top-0 h-[600px] w-[600px] animate-pulse rounded-full bg-primary/10 blur-[140px]"></div>
        <div className="absolute -right-[10%] bottom-0 h-[500px] w-[500px] animate-pulse rounded-full bg-secondary/10 blur-[120px]" style={{
        animationDelay: "2s"
      }}></div>
      </div>

      <div className="container relative z-10 mx-auto">
        <EcommerceProductsProvider wp_query={{
        per_page: 1,
        product_tag: [22]
      }}>
          <AuthorityHeader />
        </EcommerceProductsProvider>
      </div>
    </section>;
}